import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Button,
  Box,
  Menu,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
  Card,
  CardContent,
  Breadcrumbs,
  Stack,
  CircularProgress,
  Alert,
  Fade,
  Paper,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Dialog,
  DialogContent,
  Switch,
  TableSortLabel,
  OutlinedInput,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { BUTTON_STYLES } from "../../styles/componentStyles";
import NavBar from "../NavBar";
import api from "../../axiosInstance";
import { useTheme } from "@emotion/react";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteConfirmationDialog from "../DeleteConfirmationDialog";
import { toast, ToastContainer } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";

// Column config and visibility state
const allColumns = [
  {
    key: "id",
    label: "Id",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.id,
  },
  {
    key: "courseId",
    label: "Course Id",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.courseId,
  },
  {
    key: "popUpId",
    label: "Popup Id",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.popUpId,
  },
  {
    key: "courseName",
    label: "Course Name",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.courseName,
  },
  {
    key: "courseCode",
    label: "Course Code",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.courseCode,
  },
  {
    key: "popUpName",
    label: "Popup Name",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.popUpName,
  },
  {
    key: "active",
    label: "Active",
    getValue: (r) => (r.active ? "Yes" : "No"),
  },
];
const defaultVisibleKeys = new Set([
  "id",
  "courseId",
  "popUpId",
  "courseName",
  "courseCode",
  "popUpName",
  "active",
]);

const STORAGE_KEY = "popupCouresMapVisibleColumns";

function ViewPopUpMap() {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [popupCourseMap, setPopupCourseMap] = useState([]);

  const [openNew, setOpenNew] = useState(false);
  const handleNewClose = () => setOpenNew(false);
  const [selectedstates, setSelectedStates] = useState("1" || "");
  const [searchQuery, setSearchQuery] = useState(() => {
    return localStorage.getItem("popupCourseMaps") || "";
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openImage, setOpenImage] = useState(null);
  const [popupCourseMapEdit, setPopupCourseMapEdit] = useState(null);
  const [dense, setDense] = useState(true);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");
  const [refreshList, setRefreshList] = useState(0);
  const [popups, setPopups] = useState([]);
  const [selectedPopup, setSelectedPopup] = useState("");
  //  Filter
  const filteredpopupCourseMap = popupCourseMap.filter(
    (sub) =>
      !searchQuery ||
      sub.courseName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      sub.courseCode
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase()),
  );
  // Inside sorted Data your component
  const sortedData = useMemo(() => {
    if (!filteredpopupCourseMap) return [];

    return [...filteredpopupCourseMap].sort((a, b) => {
      if (!orderBy) return 0;

      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === "string") {
        return order === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (typeof aValue === "number") {
        return order === "asc" ? aValue - bValue : bValue - aValue;
      }
      if (typeof aValue === "boolean") {
        return order === "asc"
          ? Number(aValue) - Number(bValue)
          : Number(bValue) - Number(aValue);
      }

      return 0;
    });
  }, [filteredpopupCourseMap, orderBy, order]);
  // Save to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("popupCourseMaps", searchQuery);
  }, [searchQuery]);
  // Sorting logic
  const handleSort = (columnKey) => {
    const isAsc = orderBy === columnKey && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnKey);
  };

  // padding Dense
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  const handleChange = (event) => {
    setSelectedStates(event.target.value);
  };

  //Fetching thepopupCourseMap data with states id
  useEffect(() => {
    setIsLoading(true);
    api
      .get(`/api/v1/getMappedPopUps`, {
        params: {
          popupId: selectedPopup,
        },
      })
      .then((res) => setPopupCourseMap(res.data.data))
      .catch((error) => {
        console.error("There was an error fetching the book details!", error);
        setError("Failed to load books. Please try again.");
      })
      .finally(() => setIsLoading(false));
  }, [selectedPopup]);
  useEffect(() => {
    setIsLoading(true);
    api
      .get(`/api/v1/getMappedPopUps`)
      .then((res) => setPopups(res.data.data))
      .catch((error) => {
        console.error("There was an error fetching the popups details!", error);
        setError("Failed to load popups. Please try again.");
      })
      .finally(() => setIsLoading(false));
  }, []);
  // Initialize from localStorage synchronously to avoid a race with the persister effect
  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          const validKeys = new Set(allColumns.map((c) => c.key));
          const filtered = arr.filter((k) => validKeys.has(k));
          if (filtered.length > 0) {
            return new Set(filtered);
          }
        }
      }
    } catch {}
    return new Set(Array.from(defaultVisibleKeys));
  });

  const [columnsMenuAnchor, setColumnsMenuAnchor] = useState(null);
  const openColumnsMenu = Boolean(columnsMenuAnchor);

  // Persist column config to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(Array.from(visibleColumns)),
      );
    } catch {}
  }, [visibleColumns]);

  const handleOpenColumnsMenu = (e) => setColumnsMenuAnchor(e.currentTarget);
  const handleCloseColumnsMenu = () => setColumnsMenuAnchor(null);
  const toggleColumn = (key) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  // Helper function to get boolean chip styling
  const getBooleanChip = (value) => {
    const normalized = value === true || value === "true" || value === "Yes";
    return (
      <Chip
        label={normalized ? "Yes" : "No"}
        color={normalized ? "success" : "error"}
        size="small"
        variant="outlined"
      />
    );
  };

  // Helper function to get content type chip styling
  const getContentTypeChip = (type) => {
    const typeConfig = {
      text: { color: "primary", label: "Text" },
      image: { color: "secondary", label: "Image" },
      video: { color: "success", label: "Video" },
      link: { color: "info", label: "Link" },
    };

    const config = typeConfig[type?.toLowerCase()] || {
      color: "default",
      label: type || "Unknown",
    };
    return <Chip label={config.label} color={config.color} size="small" />;
  };
  //   Page nation handel changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // page nation rows handles
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  // pagenation code
  const paginatedpopupCourseMap = sortedData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  // Columns Field showing obeject
  const visibleColumnDefs = allColumns.filter((c) => visibleColumns.has(c.key));
  // Deletion confirm dialog box open and close.
  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedId(null);
  };
  // Delete The popup record api fetch data
  const handleDelete = async () => {
    try {
      await api.delete(`/api/v1/deletePopupMapping/${selectedId}`);

      // If deletion is successful, update local state update
      setPopupCourseMap((prev) => prev.filter((row) => row.id !== selectedId));
      toast.success("Record deleted successfully.!", {
        position: "top-right",
        autoClose: 3000,
      });
      setOpen(false);
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error("Failed to delete the record. Please try again.");
    }
  };
  // opening Adding page data in onclick
  const handleNewOpen = () => {
    setOpenNew(true);
    setPopupCourseMapEdit([]);
  };
  // Editing page data in onclick
  const handleEditClick = (rowData) => {
    handleNewOpen();
    setPopupCourseMapEdit(rowData);
  };
  console.log(popupCourseMap);

  const handleFormSuccess = (newItem) => {
    console.log("hello");

    if (!newItem || !(newItem.id || newItem.planId)) {
      console.warn("Invalid item received from form", newItem);
      return;
    }
    // update locally
    setPopupCourseMap((prev) => {
      const exists = prev.some(
        (item) => (item.id || item.planId) === (newItem.id || newItem.planId),
      );

      // If editing: replace the item
      if (exists) {
        return prev.map((item) => (item.id === newItem.id ? newItem : item));
      } else {
        // If adding: push new item
        return [newItem, ...prev];
      }
    });

    setPopupCourseMapEdit(null);
  };
  return (
    <>
      {/* <NavBar /> */}
      <ToastContainer />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // column on mobile, row on desktop
          justifyContent: { xs: "flex-start", md: "space-between" }, // start on mobile, space-between on desktop
          alignItems: { xs: "stretch", md: "center" }, // stretch on mobile, center on desktop
          gap: { xs: 1, md: 0 }, // spacing between items
          mb: 2,
          marginLeft: "10px",
          marginTop: "10px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/booklist">
            Books List
          </Link>
          <Link underline="hover" color="inherit" to="/BannerManagement">
            Banners
          </Link>
          <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
            PopUps Courses Mapping
          </Typography>
        </Breadcrumbs>

        <Box>
          {/* Action Buttons */}
          <Stack
            direction="row"
            spacing={2}
            flexWrap="wrap"
            useFlexGap
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 1,
              flexWrap: { xs: "wrap", md: "nowrap" }, // wrap buttons on mobile
              mt: { xs: 1, md: 0 },
              marginRight: "10px",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<ViewColumnIcon />}
              onClick={handleOpenColumnsMenu}
              sx={{
                minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                fontSize: { xs: "10px", md: "12px" },
              }}
            >
              Columns
            </Button>
            <Menu
              anchorEl={columnsMenuAnchor}
              open={openColumnsMenu}
              onClose={handleCloseColumnsMenu}
              PaperProps={{
                sx: {
                  width: 200,
                  maxHeight: 500,
                  overflowY: "auto",
                  borderRadius: 2,
                },
              }}
            >
              {allColumns.map((col) => (
                <FormControlLabel
                  key={col.key}
                  control={
                    <Checkbox
                      checked={visibleColumns.has(col.key)}
                      onChange={() => toggleColumn(col.key)}
                    />
                  }
                  label={col.label}
                  sx={{ pl: 1, pr: 2 }}
                />
              ))}
            </Menu>
            {/* <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleNewOpen}
                {...BUTTON_STYLES.primary}
                sx={{
                  minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                  fontSize: { xs: "10px", md: "12px" },
                }}
              >
                Add popupCourseMaps
              </Button> */}
          </Stack>
        </Box>
      </Box>
      {/* Search Section */}
      <Card sx={{ margin: { xs: "0 8px", md: "0 12px" }, boxShadow: 1 }}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                minWidth: { xs: "80%", md: "80%" },
                display: "flex",
                width: "40%",
                alignItems: "center",
                gap: 2,
              }}
            >
              <FormControl size="small" fullWidth sx={{ maxWidth: 400 }}>
                <InputLabel>Select Popup</InputLabel>

                <Select
                  sx={{ textAlign: "left" }}
                  label="Select Popup"
                  value={selectedPopup}
                  onChange={(e) => setSelectedPopup(e.target.value)}
                  input={<OutlinedInput label="Select Popup" />}
                >
                  <MenuItem value="">None</MenuItem>
                  {popups
                    .filter(
                      (popup, index, self) =>
                        index ===
                        self.findIndex((p) => p.popUpId === popup.popUpId),
                    )
                    .map((popup) => (
                      <MenuItem value={popup.popUpId} key={popup.id}>
                        {popup.id} {"-"} {popup.popUpName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                placeholder="Search with Course Name or Course Code..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
                sx={{ maxWidth: 400 }}
              />
              <Typography
                sx={{ display: { xs: "none", md: "block" } }}
                variant="body2"
                color="text.secondary"
              >
                {
                  sortedData.filter(
                    (sub) =>
                      sub.courseName
                        ?.toLowerCase()
                        .includes(searchQuery.toLowerCase()) ||
                      sub.courseCode
                        ?.toString()
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()),
                  ).length
                }{" "}
                of {popupCourseMap.length} Popup CouresMap items
              </Typography>
            </Box>
            <Box>
              {/* Dense toggle */}
              <Tooltip title="Dense padding" arrow>
                <FormControlLabel
                  control={
                    <Switch
                      checked={dense}
                      onChange={handleChangeDense}
                      color="primary"
                    />
                  }
                />
              </Tooltip>
            </Box>
          </Box>
          <Typography
            sx={{ display: { xs: "block", md: "none" }, textAlign: "left" }}
            variant="body2"
            color="text.secondary"
          >
            {
              sortedData.filter(
                (sub) =>
                  sub.courseName
                    ?.toLowerCase()
                    .includes(searchQuery.toLowerCase()) ||
                  sub.courseCode
                    ?.toString()
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase()),
              ).length
            }{" "}
            of {popupCourseMap.length} Popup CouresMap items
          </Typography>
        </CardContent>
      </Card>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      {!isLoading && (
        <Fade in={!isLoading}>
          <Paper
            sx={{
              width: "98%",
              mx: "auto",
              overflow: "hidden",
              boxShadow: 2,
              marginBottom: "20px",
            }}
          >
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table
                stickyHeader
                aria-label="news table"
                size={dense ? "small" : "medium"}
              >
                <TableHead>
                  <TableRow>
                    {visibleColumnDefs.map((c) => (
                      <TableCell
                        key={c.key}
                        sx={{
                          padding: "10px 5px ",
                          backgroundColor: "#17479e",
                          color: "white",
                          fontWeight: 600,
                          position: "sticky",
                          top: 0,
                          zIndex: 3,
                          ...c.cellCss,
                        }}
                        sortDirection={orderBy === c.key ? order : false}
                      >
                        <TableSortLabel
                          active={orderBy === c.key}
                          direction={orderBy === c.key ? order : "asc"}
                          onClick={() => handleSort(c.key)}
                          sx={{
                            color: "#ffffff !important",
                            "&.Mui-active": {
                              color: "#ffffff !important",
                            },
                            "& .MuiTableSortLabel-icon": {
                              color: "#ffffff !important",
                            },
                          }}
                        >
                          {c.label}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                    <TableCell
                      sx={{
                        backgroundColor: "#17479e",
                        color: "white",
                        fontWeight: 600,
                        minWidth: 120,
                        textAlign: "center",
                        position: "sticky",
                        top: 0,
                        right: 0,
                        zIndex: 4,
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(paginatedpopupCourseMap) &&
                  paginatedpopupCourseMap.length > 0 ? (
                    paginatedpopupCourseMap
                      .filter(
                        (sub) =>
                          sub.courseName
                            ?.toLowerCase()
                            .includes(searchQuery.toLowerCase()) ||
                          sub.courseCode
                            ?.toString()
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()),
                      )
                      .map((row) => (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "rgba(0, 0, 0, 0.02)",
                            },
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.04)",
                            },
                          }}
                        >
                          {visibleColumnDefs.map((c) => (
                            <TableCell
                              key={c.key}
                              sx={{ padding: "10px 10px", ...c.cellCss }}
                            >
                              {(() => {
                                const value = c.getValue(row);
                                const key = c.key;

                                // Optional debug

                                if (key === "price" || key === "actualPrice") {
                                  return `₹ ${value}`;
                                }
                                if (key === "active") {
                                  return getBooleanChip(value);
                                }
                                return value;
                              })()}
                            </TableCell>
                          ))}
                          <TableCell
                            sx={{
                              align: "center",
                              padding: "10px 10px",
                              minWidth: "120px",
                              position: "sticky",
                              right: 0,
                              backgroundColor: "#fff",
                              zIndex: 1,
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={0.5}
                              justifyContent="center"
                            >
                              {/* <Tooltip
                                  title="Edit popupCourseMap"
                                  arrow
                                  placement="top"
                                >
                                  <IconButton
                                    color="primary"
                                    onClick={() => handleEditClick(row)}
                                    size="small"
                                    sx={{
                                      "&:hover": {
                                        backgroundColor: "primary.light",
                                        color: "white",
                                      },
                                    }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip> */}
                              <Tooltip
                                title="Delete Popup Coures Map"
                                arrow
                                placement="top"
                              >
                                <IconButton
                                  color="error"
                                  onClick={() => handleClickOpen(row.id)}
                                  size="small"
                                  sx={{
                                    "&:hover": {
                                      backgroundColor: "error.light",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={visibleColumnDefs.length + 1}
                        sx={{ textAlign: "center", py: 4 }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography variant="h6" color="text.secondary">
                            {searchQuery
                              ? "No popupCourseMaps found matching your search"
                              : "No popupCourseMaps available"}
                          </Typography>
                          {searchQuery && (
                            <Button
                              variant="outlined"
                              onClick={() => setSearchQuery("")}
                              startIcon={<SearchIcon />}
                            >
                              Clear Search
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 30, 50, 100]}
              component="div"
              count={filteredpopupCourseMap.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                borderTop: "1px solid",
                borderColor: "divider",
                "& .MuiTablePagination-toolbar": {
                  paddingLeft: 2,
                  paddingRight: 2,
                },
              }}
            />
          </Paper>
        </Fade>
      )}
      {/* Banner modal */}
      {/* <popupCourseMapModal
          open={openNew}
          onClose={handleNewClose}
          popupCourseMapEdit={popupCourseMapEdit}
          onSuccess={handleFormSuccess}
        /> */}
      {/* Confirm Delete Dialog */}
      <DeleteConfirmationDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this news item? This action cannot be undone."
        confirmText="DELETE"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
      <Dialog
        open={!!openImage}
        onClose={() => setOpenImage(null)}
        maxWidth="md"
      >
        <DialogContent>
          <Box position="relative">
            <IconButton
              aria-label="close"
              onClick={() => setOpenImage(null)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <img
              src={openImage}
              alt="Preview"
              style={{ width: "100%", height: "auto", borderRadius: 4 }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ViewPopUpMap;
